// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Button$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";

function SuspensionTimeRangeSelection$DurationFallBackUi(Props) {
  return React.createElement("div", {
              className: "select-timing disabled-timing"
            }, React.createElement("p", {
                  className: "label"
                }, "Suspension Time Range"), $$Array.of_list(List.mapi((function (_index, duration) {
                        return React.createElement(Button$Catalyst.make, {
                                    text: duration.tag,
                                    cb: (function (param) {
                                        
                                      }),
                                    className: "btn-primary",
                                    disabled: true
                                  });
                      }), {
                      hd: {
                        hours: 1,
                        tag: "1 Day"
                      },
                      tl: {
                        hd: {
                          hours: 1,
                          tag: "2 Days"
                        },
                        tl: {
                          hd: {
                            hours: 1,
                            tag: "7 Day"
                          },
                          tl: {
                            hd: {
                              hours: 1,
                              tag: "15 Days"
                            },
                            tl: {
                              hd: {
                                hours: 1,
                                tag: "Indefinate"
                              },
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    })));
}

var DurationFallBackUi = {
  make: SuspensionTimeRangeSelection$DurationFallBackUi
};

function SuspensionTimeRangeSelection(Props) {
  var selectedReasonId = Props.selectedReasonId;
  var suspensionReasons = Props.suspensionReasons;
  var handleUpdate = Props.handleUpdate;
  var selectedHourIndex = Props.selectedHourIndex;
  var getSelectedReason = function (param) {
    return List.nth(List.filter(function (record) {
                      return record.id === selectedReasonId;
                    })(suspensionReasons), 0).suspension_durations;
  };
  if (selectedReasonId > -1) {
    return React.createElement("div", {
                className: "select-timing"
              }, React.createElement("label", {
                    className: "label"
                  }, "Suspension Time Range"), $$Array.of_list(List.mapi((function (_index, duration) {
                          return React.createElement(Button$Catalyst.make, {
                                      text: duration.tag,
                                      cb: (function (param) {
                                          return Curry._2(handleUpdate, _index, duration);
                                        }),
                                      className: "btn-primary " + (
                                        selectedHourIndex === _index ? "active" : "timing-btn"
                                      )
                                    });
                        }), getSelectedReason(undefined))));
  } else {
    return React.createElement(SuspensionTimeRangeSelection$DurationFallBackUi, {});
  }
}

var make = SuspensionTimeRangeSelection;

export {
  DurationFallBackUi ,
  make ,
  
}
/* react Not a pure module */
